import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useCadastroPesquisaListaFilters
 */

type State = {
  field: number | null;
  value: string | null;
  status: number | null;
};

type Actions = {
};

export const useCadastroPesquisaListaFilters = create<State & Actions>((set) => ({
  field: 1,
  value: null,
  status: 2,
}));

export const initialCadastroPesquisaListaFiltersState: State = {
  field: 1,
  value: null,
  status: 2,
};